import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  statusLabel: {
    width: '15%',
  },
});
